// This is a temporary shim to update the new hotwire tension row from react components
/* eslint-disable no-unused-vars */
export default async function index(organizationId, viewerId, tensionId) {
  Glassfrog.hotwire.refreshTurboFrame('page-frame', document.location)
}
/* eslint-enable no-unused-vars */
